import React, {useCallback, useState} from "react";
import {Table} from "react-bootstrap";
import {QnaCreateModal} from "./QnaCreateModal";
// import moment from "moment";
// import "moment/locale/ko";
import {deleteQNA} from "../../Wizard/_redux/wizardCrud";
import {QnaUpdateModal} from "./QnaUpdateModal";

export function OrderQnA({ data, qna, qnaData }) {
    const [show, setShow] = useState(false);
    const [updateShow, setUpdateShow] = useState(false);
    const [selectedQna, setSelectedQna] = useState({});
    const onShow = useCallback(
        () => {
            setShow(true)
            setSelectedQna({})
        },
        [],
    );

    const onHide = useCallback(
        () => {
            setShow(false)
        },
        [],
    );
    const onUpdateHide = useCallback(
        () => {
            setUpdateShow(false)
        },
        [],
    );
    const deleteButton = useCallback(
        (idx) => {
            deleteQNA(idx)
                .then(res => {
                    const result = res.data
                    if(result === "success") {
                        qnaData()
                    }
                })
                .catch(err => console.error(err))
            },
        [qnaData],
    );

    const updateButton = useCallback(
        (data) => {
            setUpdateShow(true)
            setSelectedQna(data)

        },
        [],
    );


    return (
        <>
            <Table striped bordered >
                <thead className="thead-dark">
                <tr>
                    <th className="d-flex justify-content-between">
                        QNA
                        <button className="form-control w-25 float-right p-0 m-0 h-50" onClick={onShow}>질문하기</button>

                    </th>
                    {/*<th>선택</th>*/}
                </tr>
                </thead>
                <tbody>
                    {
                        qna.map((item, i) => {
                            return (
                                <React.Fragment key={"order_qna-"+ i}>
                                    <tr>
                                        <td>
                                            {`질문 : ${item.contents}`}
                                            {
                                                !item.answers &&
                                                <>
                                                <span className="fa-pull-right ml-2" onClick={() => deleteButton(item.idx)} style={{cursor: "pointer"}}>
                                                    <i className="fa fa-trash" aria-hidden="true"></i>
                                                </span>
                                                <span className="fa-pull-right ml-2" onClick={()=> updateButton(item)} style={{cursor: "pointer"}}>
                                                    <i className="fa fa-edit" aria-hidden="true"></i>
                                                </span>
                                                </>
                                            }
                                        </td>
                                        {/*<td>{moment(item.crt_dtm).locale('ko').format("YYYY-MM-DD hh:mm:ss a dddd")}</td>*/}
                                    </tr>
                                    <tr>
                                        <td>
                                            <i className="fa fa-reply fa-rotate-180" aria-hidden="true"></i>
                                            {` 답변 : ${item.needAnswer === "Y" ? "답변대기중" : item.answers.contents}`}
                                        </td>
                                        {/*<td>{item.answers ? moment(item.answers.crt_dtm).locale('ko').format("YYYY-MM-DD hh:mm:ss a dddd") : ''}</td>*/}
                                    </tr>
                                </React.Fragment>
                            )
                        })
                    }
                </tbody>
            </Table>

            <QnaCreateModal show={show} onHide={onHide} data={data} qnaData={qnaData} />
            <QnaUpdateModal show={updateShow} onHide={onUpdateHide} qna={selectedQna} qnaData={qnaData}/>
        </>
    )
}